import TARGET from 'TARGET'
export async function LoadConfig() {
    let conf = await fetch('config.json')
    window.config = await conf.json();
    
    if (TARGET == 'development') {
        var hostname = 'https://' + window.location.hostname // + (window.location.port ? ':' + window.location.port : '');

        for (let prop in window.config) {
            if (typeof window.config[prop] === 'string') {
                if (window.config[prop].indexOf("https://[FQDN]") > -1) {
                    window.config[prop] = window.config[prop].replace("https://[FQDN]", hostname);
                }
            }
        }
    }
    return window.config;
}